// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"525":"a65c1915","914":"b5ed4a10"}[chunkId] + ".css";
};